import { Injectable, inject } from '@angular/core';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { EdependencyLevel } from '@df/catalog/model';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { LocalCategory } from '../../../category/category.decorator';

@Injectable({
  providedIn: 'root'
})
export class GoogleShoppingCategoryService {
  private readonly app = inject(App);

  async loadCategory(product: Product<IProductDataV3>, parent?: Product<IProductDataV3>): Promise<LocalCategory<ICategoryDataV3> | undefined> {
    try {
      const categoryId = this.getCategoryId(product, parent);
      if (!categoryId) {
        return undefined;
      }

      const category = this.app.resources.category.getCreate(categoryId) as LocalCategory<ICategoryDataV3>;
      await category.load(3, {
        safe: true,
        dependencyLevel: EdependencyLevel.details
      });

      return category.data ? category : undefined;
    } catch {
      return undefined;
    }
  }

  private getCategoryId(product: Product<IProductDataV3>, parent?: Product<IProductDataV3>): number | undefined {
    const productData = product?.data as unknown as Record<string, unknown> | undefined;
    const parentData = parent?.data as unknown as Record<string, unknown> | undefined;
    const rawCategoryId = productData?.['google_shopping_category_id'] || parentData?.['google_shopping_category_id'];
    const categoryId = Number(rawCategoryId);

    return Number.isFinite(categoryId) && categoryId > 0 ? categoryId : undefined;
  }
}
